import { Grid, useEventCallback } from '@mui/material';
import { memo } from 'react';
import ForeignStateList, { ForeignStateVM } from 'shell/components/shared/foreign-state-list';
import PmiTextField from 'shell/components/shared/text-field';
import { ForeignVM } from 'mutation/view-models/registration-beware';
import MunicipalityForeignList, {
  MunicipalityForeignAnprVM,
} from 'shell/components/shared/municipality-foreign-list';
import { FormikErrors, FormikTouched } from 'formik';

interface ForeignStateProps {
  values?: ForeignVM;
  onChange: (key: keyof ForeignVM, value: ForeignVM[keyof ForeignVM]) => void;
  errors?: FormikErrors<ForeignVM>;
  touched?: FormikTouched<ForeignVM>;
}

const ForeignStateComponent = ({
  onChange,
  values,
  errors,
  touched,
}: ForeignStateProps): React.ReactElement => {
  const onChangeForeignStateList = useEventCallback(
    (foreignState: ForeignStateVM | null | undefined) => {
      onChange('foreignState', foreignState);
    }
  );

  const onChangeMunicipalityForeign = useEventCallback(
    (value: MunicipalityForeignAnprVM | null) => {
      onChange('foreignMunicipality', value);
    }
  );

  return (
    <Grid item container spacing={2} alignItems="center">
      <Grid item xs={12} md={8}>
        <ForeignStateList
          value={values?.foreignState || null}
          onChange={onChangeForeignStateList}
          label="Stato estero"
          id="foreignStateBirth"
          error={touched?.foreignState && Boolean(errors?.foreignState)}
        />
      </Grid>
      <Grid item xs={12} md={8}>
        <MunicipalityForeignList
          value={values?.foreignMunicipality || null}
          onChange={onChangeMunicipalityForeign}
          label="Comune estero"
          id="municipalityForeign"
          foreignStateIstatCode={values?.foreignState?.istatCode}
          error={touched?.foreignMunicipality && Boolean(errors?.foreignMunicipality)}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          aria-label="Provincia o Contea"
          label="Provincia/Contea"
          id="foreignProvince"
          name="foreignProvince"
          fullWidth
          type="text"
          variant="outlined"
          value={values?.foreignMunicipality?.province || ''}
          disabled
        />
      </Grid>
    </Grid>
  );
};

ForeignStateComponent.displayName = 'Modal - Foreign State component';

const ForeignState = memo(ForeignStateComponent);

export default ForeignState;
